import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { Department } from '../Models/department.model';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  url = environment.Url+'Departments';
  dptDoctors = environment.Url+'Departments/doctors';
  dptNurses = environment.Url+'Departments/nurses';
  dptPatients = environment.Url+'Departments/patients';

  header = new HttpHeaders({

    'Authorization': 'token' + localStorage.getItem('token')

  })

  constructor(private http: HttpClient) { }




  registerDepartment(body){
    return this.http.post<Department>(this.url,body).pipe(
     catchError(this.handleError)
   );
     }

   getDepartments(){
    return this.http.get<Department[]>(this.url).pipe(catchError(this.handleError)
    
    );
   }
   getDepartmentById(id){
    return this.http.get<Department>(this.url+'/'+id)
  }
   getDepartmentDoctors(id){
    return this.http.get<Department>(this.dptDoctors+'/'+id)
  }
   getDepartmentNurses(id){
    return this.http.get<Department>(this.dptNurses+'/'+id)
  }
   getDepartmentPatients(id){
    return this.http.get<Department>(this.dptPatients+'/'+id)
  }

  updateDepartment(id,body){
   return this.http.put<Department>(this.url+'/'+id,body).pipe(catchError(this.handleError));
  }

  deleteDepartment(id){
return this.http.delete<Department>(this.url+'/'+id).pipe(catchError(this.handleError));
  }











  
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error)
        return throwError(
          error.error
        )


      }
     else if(error.status ==401){
       return throwError('invalid username or password')

     }
      else if (error.status == 0) {
        return throwError(
          'network failure please try again later '
        )
      }
      return throwError(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


}



